import { useTranslation } from "react-i18next";
import { Skeleton } from "../ui/Skeleton";

export function PlayableGridSkeleton({ className = "grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6" }: { className?: string }) {
	const { t } = useTranslation();
	return (
		<div
			role="status"
			aria-label={t("discover.loadingContent")}
			className={className}
		>
			{Array.from({ length: 12 }, (_, index) => (
				<div key={index} aria-hidden="true" className="min-w-0">
					<Skeleton className="aspect-[2/3] w-full rounded-lg" />
					<div className="flex min-h-16 gap-2.5 px-0.5 py-2.5 sm:gap-3">
						<Skeleton className="mt-0.5 size-10 shrink-0 rounded-full" />
						<div className="min-w-0 flex-1 space-y-2">
							<Skeleton className="h-5 w-4/5 rounded" />
							<Skeleton className="h-3 w-3/5 rounded" />
						</div>
					</div>
				</div>
			))}
		</div>
	);
}
